exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n\r\n.comment-strip {\r\n  background: #f6f6f6;\r\n  padding: 7px;\r\n  color: #b60000;\r\n  border-right: 4px solid #b60000;\r\n  /*padding-top: 15px;\r\n  padding-bottom: 15px;*/\r\n  font-size: 16px;\r\n  line-height:32px;\r\n }\r\n\r\n.clarifying-strip {\r\n  background: #f6f6f6;\r\n  padding: 7px;\r\n  color: #263c4a;\r\n  border-right: 4px solid #263c4a;\r\n  /*padding-top: 15px;\r\n  padding-bottom: 15px;*/\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  line-height:32px;\r\n }\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 338
// module chunks = 1